{
  "nickname": "Biệt danh",
  "nicknameUpdated": "Đã đặt biệt danh",
  "nicknameUpdateFailed": "Không thể đặt biệt danh",
  "nicknameHint": "Có thể dùng chữ cái hoặc số của bất kỳ ngôn ngữ nào; không dùng ký tự đặc biệt và tối đa 30 ký tự.",
  "save": "Lưu",
  "changeLoginPassword": "Đổi mật khẩu đăng nhập",
  "changeLoginPasswordSuccess": "Đổi mật khẩu đăng nhập thành công",
  "changeLoginPasswordFailed": "Không thể đổi mật khẩu đăng nhập",
  "oldPassword": "Mật khẩu cũ",
  "oldPasswordPlaceholder": "Nhập mật khẩu cũ",
  "setTransactionPassword": "Đặt mật khẩu giao dịch",
  "changeTransactionPassword": "Đổi mật khẩu giao dịch",
  "newTransactionPassword": "Mật khẩu giao dịch mới",
  "confirmTransactionPassword": "Xác nhận mật khẩu giao dịch",
  "transactionPasswordSetSuccess": "Đặt mật khẩu giao dịch thành công",
  "transactionPasswordChangedSuccess": "Đổi mật khẩu giao dịch thành công",
  "transactionPasswordSetFailed": "Không thể đặt mật khẩu giao dịch",
  "transactionPasswordChangedFailed": "Không thể đổi mật khẩu giao dịch",
  "transactionPasswordSetFailedWithCode": "Không thể đặt mật khẩu giao dịch: {{code}}"
}
